import { render, staticRenderFns } from "./ReviewReplyForm.vue?vue&type=template&id=4a8d311c"
import script from "./ReviewReplyForm.vue?vue&type=script&lang=js"
export * from "./ReviewReplyForm.vue?vue&type=script&lang=js"
import style0 from "./ReviewReplyForm.vue?vue&type=style&index=0&id=4a8d311c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports